"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionTypes = void 0;
var actionTypes = {
  FETCH: "@@brand/fetch",
  ACCESS: "@@brand/access",
  LIST: "@@brand/list",
  ALL_LIST: "@@brand/all-list",
  LIST_PB_SITE: "@@brand/list-pb-site",
  LIST_PB_REPORT: "@@brand/list-pb-report",
  DELETE: "@@brand/delete",
  ADD: "@@brand/add",
  UPDATE: "@@brand/update",
  REMOVE: "@@brand/remove",
  ADMIN_LIST: "@@brand/admin-list",
  CONTENT_LIST: "@@brand/content-list",
  ACCESS_LIST: "@@brand/access-list",
  APPLY: "@@brand/apply",
  RESET: "@@brand/reset",
  SUCCESS: "@@brand/success",
  ERROR: "@@brand/error",
  SOFT_DELETE: "@@brand/soft-delete",
  SOFT_DELETE_RESTORE: "@@brand/soft-delete-restore",
  SOFT_DELETED_LIST: "@@brand/soft-deleted-list",
  BULK_SOFT_DELETE: "@@brand/bulk-soft-delete",
  BULK_HARD_DELETE: "@@brand/bulk-hard-delete",
  BULK_RESTORE: "@@brand/bulk-restore",
  TEMP_DATA_SET: "@@data/temp-data-set"
};
exports.actionTypes = actionTypes;